import { Observable, Subject } from 'rxjs';

export class BrowserService {
    private readonly _resize$ = new Subject<boolean>();

    constructor() {
        this.onResize();
        window.onresize = () => {
            this.onResize();
        }
    }

    get resize$(): Observable<boolean> {
        return this._resize$.asObservable();
    }
    
    get getWidth() : number {
        return document.documentElement.clientWidth;
    }

    get isMobile() : boolean {
        const breakpoint = 960;
        if (this.getWidth < breakpoint) {
            return true;
        } else {
            return false;
        }
    }

    private onResize(): void {
        this._resize$.next(true);
    }
}
